import { Options } from '@angular-slider/ngx-slider';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewChildren, QueryList, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants, USER_TYPE } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { GigsumoService, pauseForSeconds } from 'src/app/services/gigsumoService';
import { JobService, updateStatusCheckBox } from 'src/app/services/job.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { filterConfig } from 'src/app/types/filterConfig';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NgbAccordionModule, NgbAccordion, NgbAccordionConfig } from '@ng-bootstrap/ng-bootstrap';
import { CustomerFilterTemplateComponent } from '../../bussinesspages/user-management/customer-filter-template/customer-filter-template.component';
import { NgIconComponent } from '@ng-icons/core';

@Component({
  selector: 'app-candidate-vertical-filter-template',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonSkeletonComponent, NgbAccordionModule, CustomerFilterTemplateComponent, NgIconComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // Component-local NgbAccordionConfig with animation off — the ngb collapse
  // animation relies on Bootstrap 5's .collapsing CSS which this Bootstrap 3
  // app doesn't ship, so it was a dead ~350ms delay on every toggle. Also
  // covers the nested app-customer-filter-template accordions. Mirrors
  // job-filter-vertical-template.
  providers: [NgbAccordionConfig],
  templateUrl: './candidate-vertical-filter-template.component.html',
  styleUrls: ['./candidate-vertical-filter-template.component.scss']
})
export class CandidateVerticalFilterTemplateComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() viewType: string;
  @Input() filterChanges: string;
  nameData = "Hello";
  candidateSourceFlag: boolean = false
  // isLoading drives the full-panel overlay: shown while the filter first
  // opens AND while a Business Network pick reloads (both lists refresh, so a
  // global loader is wanted there). Per-dropdown open/search use the scoped
  // flags below; scroll pagination uses the *More flags (bottom spinner).
  isLoading: boolean = false
  publishedByLoading: boolean = false
  customerLoading: boolean = false
  // Scroll pagination ("load next 5") loader. Kept separate from
  // customerLoading because that one REPLACES the list with a spinner, which
  // unmounts the scrolled list and snaps it back to the top. loadingMore shows
  // a small spinner at the BOTTOM while the existing rows stay put.
  customerLoadingMore: boolean = false
  jobClassificationFlag: boolean = false
  availableForFlag: boolean = false
  candidateFlag: boolean = false
  workAuthFlag: boolean = false
  locationFlag: boolean = false
  workTypeFlag: boolean = false
  experienceFlag: boolean = false
  suggestionStick: boolean = false
  previousSearchAfterKey = null;
  benchSalesCandidates: any;
  myCandidates: boolean = true
  featured: boolean = false;
  filterOn: boolean = false
  count: number = 0
  filteredCandidates: boolean = false
  response: any = [];
  dataPass: any = [];
  stopscrollFlag: boolean = false
  candidateLength: number
  userType = localStorage.getItem('userType')
  jobfilter = false;
  totalFilters: number = 0;
  filterdata: any = {};
  candidateFoundStatus: any = "Fetching Candidates..."
  dataPasstoSkillwidgets: any;
  removeSelected: any;
  FeaSugg: boolean = false
  activeStatus: boolean = null;
  removeTagvalues: any;
  stateListCA: any;
  stateListIN: any;
  stateListAU: any;
  candidateFilterForm: UntypedFormGroup;
  countryList: any = [];
  candidateSource: any = [];
  engagementType: any = [];
  status: any = [];
  filterApplied: boolean = false
  workAuthorization: any = [];
  activeIds = [];
  @ViewChild("lgModal") lgModal;
  highValue2: number;
  refreshCandidates: Subscription
  filterReload: Subscription
  value: number = 0;
  highValue: number = 0;
  options: Options = {
    floor: 0,
    ceil: 50
  };
  previousSearchAfterKey1 = null;
  statusFlag: boolean = false
  myCandidateFlag: boolean = false
  countryFlag: boolean = false
  totalExperienceFlag: boolean = false
  benchCandidatesFlag: boolean = false
  remoteWorkFlag: boolean = false
  postedInDaysFlag: boolean = false
  experienceToFlag: boolean = false
  experienceFromFlag: boolean = false
  cityFlag: boolean = false
  zipcodeFlag: boolean = false
  workFromHomeFlag: boolean = false
  stateFlag: boolean = false
  relocationRequiredFlag: boolean = false
  engagementTypeFlag: boolean = false
  workAuthorizationFlag: boolean = false
  featuredCandidatesFlag: boolean = false
  totalCandidatesCount: number = 0;
  datas: any = {};
  postDateApplied: boolean = false
  value1: number = 0;
  highValue1: number = 0;
  options1: Options = {
    floor: 0,
    ceil: 99
  };
  owner: boolean = false
  showsuggJobsData: any = [];
  formDataPost: any = {};
  keyarrayCandidatesouces = CandidateService.FILTER_ELEMENT;
  keysarrWorks = ["All", "Onsite", "Remote", "Hybrid"];
  searchContent: any;
  userIdStorage = localStorage.getItem('userId')
  candiSourceSearchRoute = null
  searchUserType: any
  candiSourceSelectNetRoute: any
  ScreenLoadBool: boolean = false
  subscription: Subscription;
  isAccordionOpen: boolean;
  messageData: any;
  messagemodelflag: Boolean = false;
  searchResult: Array<string> = ['Personal Networks' , 'Member Network'];
  membershipType = localStorage.getItem('MemberShipType');

  //job classification
  availableForCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Corp To Corp', selected: false, disable: false },
    { label: 'W2 - Contract', selected: false, disable: false },
    { label: 'W2 - Full Time', selected: false, disable: false },
    { label: 'Part Time', selected: false, disable: false },
    { label: 'Freelance', selected: false, disable: false },
    { label: 'Internship', selected: false, disable: false },
    { label: 'Contract to Hire', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false },
    // { label: 'Direct Hire', selected: false, disable: false },
  ];
  availablecheckbox = [
    { label: 'All', selected: false, disable: false },
    { label: 'Immediate', selected: false, disable: false },
    { label: '1 Week', selected: false, disable: false },
    { label: '2 Weeks', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false }

  ];
  candidate_status = [
    { label: 'ALL', selected: false, disable: false },
    { label: 'APPLIED', selected: false, disable: false },
    { label: 'SHORTLISTED', selected: false, disable: false },
    { label: 'REJECTED', selected: false, disable: false },
    { label: 'INTERVIEW SCHEDULED', selected: false, disable: false },
    { label: 'REJECT', selected: false, disable: false },
    { label: 'ACCEPT', selected: false, disable: false },
    { label: 'SELECTED', selected: false, disable: false },
    { label: 'OFFERED', selected: false, disable: false },
    { label: 'PREONBOARDED', selected: false, disable: false },
    { label: 'ONBOARDED', selected: false, disable: false },
    { label: 'OFFER WITHDRAWN', selected: false, disable: false },
    { label: 'OFFER DECLINED', selected: false, disable: false },
    { label: 'OFFER ACCEPTED', selected: false, disable: false }

  ];
  statusCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Available', selected: false, disable: false },
    { label: 'Draft', selected: false, disable: false },
    { label: 'Unavailable', selected: false, disable: false },
  ];
  workModeCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Onsite', selected: false, disable: false },
    { label: 'Remote', selected: false, disable: false },
    { label: 'Hybrid', selected: false, disable: false },
  ];

  EXPERIENCE_ANY = GigsumoConstants.EXPERIENCE_ANY;
  EXPERIENCE_JUNIOR = GigsumoConstants.EXPERIENCE_JUNIOR;
  EXPERIENCE_MID_LEVEL = GigsumoConstants.EXPERIENCE_MID_LEVEL;
  EXPERIENCE_SENIOR = GigsumoConstants.EXPERIENCE_SENIOR;
  EXPERIENCE_ARCHITECT = GigsumoConstants.EXPERIENCE_ARCHITECT;
  POSTED_ANY = GigsumoConstants.POSTED_ANY;
  POSTED_TODAY = GigsumoConstants.POSTED_TODAY;
  POSTED_LAST_7_DAYS = GigsumoConstants.POSTED_LAST_7_DAYS;
  POSTED_LAST_14_DAYS = GigsumoConstants.POSTED_LAST_14_DAYS;
  POSTED_LAST_30_DAYS = GigsumoConstants.POSTED_LAST_30_DAYS;

  WACheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [];
  ischeckedJobSource: boolean = false
  ischeckedJobSourceAll: boolean = false
  ischeckedClientType: boolean = false
  ischeckedClientTypeAll: boolean = false
  ischeckedStatus: boolean = false
  ischeckedStatusAll: boolean = false
  ischeckedJobClassification: boolean = false
  ischeckedJobClassificationAll: boolean = false
  ischeckedWorkType: boolean = false
  ischeckedWorkTypeAll: boolean = false
  totalmsgcount: Subscription;
  colurclass = ['fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color'];
  feaJ: boolean;
  profile: any
  networkflag: boolean = false;
  receiveFilterData: Subscription;
  resetFilter: Subscription;
  countSouce: number = 0;
  sendProfileData: any = {}
  validTotalPoints: boolean
  totalCount
  listingCount = 0;
  freelanceCount = 0;
  creditsConsume: any = 0;
  availablePoints;
  queryParamsValues: any
  valid: boolean = true;
  usStatesList = []
  showWorkAuthorization: boolean = false
  img: any;
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  obj1: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  yearApplied: boolean = false
  isMyCandidateShowedOnLoad: boolean = false;
  filterSubscriber: Subscription;
  isFilterOpen: boolean = false;
  @Input() candidateFilterData: filterConfig;
  @Input() businessId: any;
  @Input() hideCandidateSource: boolean = false;
  @Input() hideSubmissionStatus: boolean = false;
  @Input() hideStatus: boolean = false;
  // When true, the Candidate Source accordion shows ONLY "My Candidates" + "My Employees"
  // (used by /candidates/findOrgCandidates SuperAdmin view). All other source checkboxes
  // and the always-visible Published By / Business Networks / Customer sub-lists are hidden.
  @Input() orgCandidatesMode: boolean = false;
  // Pre-fetched employee list (e.g. from subscription/findEmployeeBenefitsAllocation).
  // Each item must expose `userId` and `fullName`. Drives the Published By picker that
  // opens when the "My Employees" checkbox is checked in orgCandidatesMode.
  @Input() employeeListInput: any[] = [];
  // Parent owns the paginated employee fetch (so it can keep the Transfer modal's
  // userList separate). We bubble the picker's debounced search + scroll up here.
  @Output() employeeSearch = new EventEmitter<string>();
  @Output() employeeScroll = new EventEmitter<void>();
  // Fires when SuperAdmin toggles "My Employees" ON. Parent listens and
  // lazily calls findEmployeeList — avoids the prefetch on every page open.
  @Output() myEmployeesToggled = new EventEmitter<void>();
  // Parent-owned loading flag — true while findEmployeeList is in flight.
  // Bound directly to the My Employees picker's [isLoading] so the spinner
  // is driven by the actual API call lifecycle.
  @Input() employeeLoadingInput: boolean = false;

  // Locally-owned flags for the OFF transition of "My Employees". When
  // the user unticks the checkbox, *ngIf would otherwise hide the picker
  // immediately. We hold it open for ~600ms while showing the spinner
  // so the off-toggle gets the same visual feedback as on-toggle, then
  // unmount.
  employeeOffShowing: boolean = false;
  employeeOffLoading: boolean = false;
  private employeeOffTimer: any = null;
  recruiterNetwork: boolean = false;
  freelancerNetwork: boolean = false;
  benchNetwork: boolean = false;
  mtaNetwork: boolean = false;
  jobseekerNetwork: boolean = false;
  submissionFilter: Array<any> = [];
  businessNetworkData: any = [];
  memberNetworks: any;
  personalNetworks: any= [];
  publishedPayload = {
    memberNetworkChosen : false,
    all : false,
    personalNetworks : [],
    users : [],
    type:"CANDIDATE",
    userId : null ,
    searchContent: null,
    searchAfterKey: null,
    limit : 10
  }
  customerPayload= {
    businessId: null,
    userId: null,
    memberNetworkChosen : false,
    businessNetworkChosen : false,
    businessNetworks: [],
    businessList: [],
    searchContent:null,
    searchAfterKey : null,
    limit: 10
  };
  filterFormData: any;
  customersPrevSearchAfterKey: any;
  customersStopScroll: boolean;
  publishedByPrevSearchAfterKey: any;
  publishedByStopScroll: boolean;
  showNetworkFilter : boolean = false
  tempBusinessNetworks: any;
  istempBusinessNetwork: boolean = false;
  memberAvailable : boolean = false;


  constructor(private apiService: ApiService, private searchData: SearchData, private gigsumoService: GigsumoService, private formBuilder: UntypedFormBuilder, private util: UtilService, private candidateService: CandidateService, private jobService: JobService, private a_route: ActivatedRoute, private router: Router, accordionConfig: NgbAccordionConfig) {
    accordionConfig.animation = false;
    this.memberAvailable = (this.userType === 'JOB_SEEKER' || this.membershipType === 'Free' || this.membershipType === 'Pro');
    this.createCandidateFilterForm();
    this.getCandidateSource();

    this.filterSubscriber = this.jobService.getSliderToggle().subscribe(value => {

      if(value.reset==true){
        this.WACheckboxes.forEach(item => item.selected = false);
        // SuperAdmin org-candidates page: slider footer Reset only clears the
        // API payload in the parent — not the template's local UI state. Gated
        // to orgCandidatesMode so the reference /candidates/filter flow is
        // untouched.
        if (this.orgCandidatesMode) {
          this.resetOrgCandidatesFilterUiState();
        }
       }

      // Brief loader on All Filter open. The slide-out is already host
      // mounted; nothing actually re-fetches, so we flip isLoading for
      // ~500ms so the existing <app-common-skeleton 'verticalCheckboxSelection'>
      // renders the same 47px purple circle the regular Job module shows.
      if (value?.value === true && this.orgCandidatesMode) {
        this.isLoading = true;
        setTimeout(() => { this.isLoading = false; }, 500);
      }

      if (value.panel == 'candidate-listing' && value.value == true) {
        this.isFilterOpen = true;

        this.openFilterSlider();
      } else {
        this.isFilterOpen = false;
        this.closeFilterSlider();
      }
    });

    this.showNetworkFilter = localStorage.getItem('MemberShipType') === "Free" ? false : true;

     this.a_route.queryParams.subscribe(params => {
      if (params.networkName && params.networkName == 'BENCH_SALES_NETWORK') {
        this.benchNetwork = true
      } else if (params.networkName && params.networkName == 'MANAGEMENT_TALENT_ACQUISITION_NETWORK') {
        this.mtaNetwork = true
      } else if (params.networkName && params.networkName == 'FREELANCE_RECRUITER_NETWORK') {
        this.freelancerNetwork = true
      } else if (params.networkName && params.networkName == 'JOB_SEEKER_NETWORK') {
        this.jobseekerNetwork = true
      }
    })

  }

  resetFilterDefault(){
        this.jobsouceCheckedAll(false);
        this.publishedPayload.personalNetworks = [];
        this.customerPayload.businessNetworks = [];
        this.publishedPayload.searchContent = "";
        this.customerPayload.searchContent = "";
        this.selectedBusinessNetworks = [];
        this.selectedPublishedBy = [];
        this.selectedSubmission = [];
        this.selectedCustomers = [];
        this.businessNetworkData =  this.tempBusinessNetworks;
        this.customerPrevSelectedValue = [];
        this.publishedByPrevSelectedValue = [];
        this.businessNetworkPrevSelectedValue = [];
        this.setToDefaulFilter();
        this.setToDefaulFilter("CUSTOMER");
        this.getPublishedBy();
        this.getBusinessCustomers();
  }

  // SuperAdmin-only reset for the org-candidates page. Clears the checkbox
  // arrays, sliders, location/experience/posted form fields, and the employee
  // picker — the state the parent's onFilterToggle('reset') doesn't touch.
  // All the filter section accordions in this template. @ViewChildren
  // does NOT cross into the child picker components, so this captures
  // only the top-level sections — used to collapse them back to the
  // page-load default on Reset.
  @ViewChildren(NgbAccordion) filterAccordions: QueryList<NgbAccordion>;

  // Collapse every filter accordion, then re-expand Source (custom-panel-1,
  // the first accordion) so the slider matches its page-load default after
  // a Reset. Scoped to orgCandidatesMode (Talent Center / Pool) only.
  private resetAccordionsToDefault() {
    if (!this.orgCandidatesMode || !this.filterAccordions) return;
    this.filterAccordions.forEach(acc => acc.collapseAll());
    const sourceAccordion = this.filterAccordions.first;
    if (sourceAccordion) sourceAccordion.expand('custom-panel-1');
  }

  // Called from the slider toggle subscription when reset=true fires and
  // orgCandidatesMode is on, AND directly by the parent header Reset
  // (customer-business-candidatelist.onResetFilters()) so both reset paths
  // clear the same fields. Exposed as public for the @ViewChild call.
  resetOrgCandidatesFilterUiState() {
    // Status defaults to ALL checked on SuperAdmin Talent Center (matches
    // the page-load pre-tick), so reset should restore that — not wipe
    // it. !hideStatus gate keeps Talent Pool unaffected (its Status is
    // hidden by the parent). Other group-checkboxes reset to fully
    // unchecked since they have no SuperAdmin pre-tick.
    this.statusCheckboxes.forEach(item => { item.selected = this.orgCandidatesMode && !this.hideStatus; item.disable = false; });
    this.workModeCheckboxes.forEach(item => { item.selected = false; item.disable = false; });
    this.availablecheckbox.forEach(item => { item.selected = false; item.disable = false; });
    this.availableForCheckboxes.forEach(item => { item.selected = false; item.disable = false; });

    // Work Authorization (WA). Missing from this method = the bug: picking a
    // WA option pushes its label into candidateSource AND flips WACheckboxes
    // selected=true, but Reset never reverted either. Mirrors the non-org
    // reset's WA wipe (resetFilternew line 1613) and also scrubs the WA
    // labels out of candidateSource so the next Apply doesn't re-send them.
    // Also hides the section — Reset wipes the country, so the WA picker
    // (which is country-driven) shouldn't keep showing an empty list.
    const waLabels = (this.WACheckboxes || [])
      .filter(item => item.label !== 'All')
      .map(item => item.label);
    this.WACheckboxes.forEach(item => { item.selected = false; item.disable = false; });
    if (waLabels.length && Array.isArray(this.candidateSource)) {
      this.candidateSource = this.candidateSource.filter(x => !waLabels.includes(x));
    }
    this.ischeckedClientType = false;
    this.showWorkAuthorization = false;

    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;

    if (this.candidateFilterForm) {
      this.candidateFilterForm.patchValue({
        city: null,
        state: null,
        country: null,
        zipCode: null,
        experienceFrom: null,
        experienceTo: null,
        postedFrom: null,
        postedTo: null,
        experienceType: 'Any (Years)',
        postedDayRange: 'Any (Days)',
      });
    }

    this.selectedEmployees = [];
    // Also clear the picker-side selection state. Without this, the
    // BehaviorSubject still holds items with enabled=true from any
    // previously picked employees, so the checkboxes inside the picker
    // stay visually ticked even after Reset.
    this.employeePrevSelectedValue = [];
    const currentEmployees = this.employeeList.getValue();
    if (currentEmployees && currentEmployees.length > 0) {
      this.employeeList.next(currentEmployees.map(item => ({ ...item, enabled: false })));
    }

    // Clear the picker's search-box text (e.g. user typed "wal" then
    // hit Reset — the input must go back to empty). The picker's
    // own ngOnChanges blanks searchValue when [resetFilter] flips to
    // true, so we toggle the form-bound flag true → false here.
    if (this.candidateFilterForm) {
      this.candidateFilterForm.get('resetFilter')?.patchValue(true);
      setTimeout(() => this.candidateFilterForm.get('resetFilter')?.patchValue(false), 0);
    }

    if (this.jobSourcesFormarray?.at(0)) {
      this.jobsouceCheckedAll(false);
      // After the cascade clear, restore the SuperAdmin defaults so the
      // page-load pre-tick of "My Talents" + "My Employees" is preserved
      // across a Reset (matches the Experience / Posted Days behaviour
      // where their "Any" defaults survive reset). Gated to
      // !hideCandidateSource so Talent Pool (where the Talent Source
      // section is hidden) doesn't re-tick anything invisible.
      if (this.orgCandidatesMode && !this.hideCandidateSource) {
        const src = this.jobSourcesFormarray.at(0);
        src.get('myCandidates')?.patchValue(true);
        src.get('myEmployees')?.patchValue(true);
      }
    }

    // Collapse expanded accordions back to the page-load default
    // (Source open, rest closed). setTimeout(0) lets the reset's
    // form/checkbox writes settle first so the collapse isn't undone
    // by a re-render in the same change-detection tick.
    setTimeout(() => this.resetAccordionsToDefault(), 0);
  }


  // recieve filter data from new-candidate component
  ngOnChanges(changes: SimpleChanges): void {

    this.publishedPayload.userId = localStorage.getItem('userId');
    this.customerPayload.userId = localStorage.getItem('userId');
    this.updateCandidateFilterData();

    if (changes.employeeListInput) {
      const list = changes.employeeListInput.currentValue || [];
      // Keep previously-ticked employees visible+enabled across paginated
      // re-fetches and server-side searches (mirror publishedByPrevSelectedValue
      // pattern). Without this, applying a search would drop selected ticks.
      const stillSelected = (this.employeePrevSelectedValue || [])
        .filter(s => this.selectedEmployees.includes(s.userId))
        .map(s => ({ ...s, enabled: true }));
      const selectedIds = new Set(stillSelected.map(s => s.userId));
      const incoming = list
        .filter(u => !selectedIds.has(u.userId))
        .map(u => ({ ...u, enabled: this.selectedEmployees.includes(u.userId) }));
      this.employeeList.next([...stillSelected, ...incoming]);
      // Parent owns the fetch, so we clear the loading flag here once the new
      // input has been pushed to the picker. customer-filter-template sets
      // superObj.isLoading=true on search/scroll and we have no other signal
      // back; this avoids the picker being stuck in the loading skeleton.
      this.isLoading = false;
    }


    if (changes.filterChanges !== undefined && changes.filterChanges.currentValue != undefined) {
      let data: any = changes.filterChanges.currentValue;

      // candidate source reset filter
      if(data.formData.resetFilter === true && this.jobSourcesFormarray.at(0) != undefined){
          this.resetFilterDefault();
          this.candidateFilterForm.patchValue(data.formData);
      }
      else{
        this.candidateFilterForm.patchValue(data.formData);
        this.filterFormData = data.formData;
        this.candidateSource = data.checkedItems;
        this.availablecheckbox = data.availiabilityCheckedItems;
        this.statusCheckboxes = data.statusCheckedItems;
        this.workModeCheckboxes=data.workMode;
        this.availableForCheckboxes = data.engageMentCheckedItems;
        this.submissionFilter = data.submissionItems;
        this.value1 = data.formData.postedFrom != null ? data.formData.postedFrom : 0;
        this.highValue1 = data.formData.postedTo != null ? data.formData.postedTo : 0;
        this.value = data.formData.experienceFrom != null ? data.formData.experienceFrom : 0;
        this.highValue = data.formData.experienceTo != null ? data.formData.experienceTo : 0;
        this.selectedSubmission = data.submissionData != undefined ? data.submissionData : [];

        let customerSelected = data.customerSelectedData === undefined ? [] : data.customerSelectedData;
        let publishedSelected = data.publishedSelectedData === undefined ? [] : data.publishedSelectedData;

        data.businessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;
        data.personalNetworks = data.personalNetworks === undefined ? [] : data.personalNetworks;

        const isMyCandidatesChecked : boolean  = data.formData.source[0].myCandidates;
        // orgCandidatesMode (SuperAdmin org-scoped view) sees Drafts across the
        // entire org regardless of which Candidate-Source sub-option is ticked,
        // so the Draft status checkbox must stay enabled.
        this.statusCheckboxes = updateStatusCheckBox(this.statusCheckboxes , this.orgCandidatesMode || (this.owner ? isMyCandidatesChecked : false) , false);


       // busniess network interaction
       if(data.formData.source[0].businessNetwork != this.istempBusinessNetwork ||
        JSON.stringify(data.businessNetworks) != JSON.stringify(this.customerPayload.businessNetworks)){
          this.setToDefaulFilter("CUSTOMER");
          this.istempBusinessNetwork = data.formData.source[0].businessNetwork;
          this.customerPayload.businessNetworkChosen = data.formData.source[0].businessNetwork
          this.customerPayload.businessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;
          this.selectedBusinessNetworks = this.istempBusinessNetwork ? (data.businessNetworks === undefined ? [] : data.businessNetworks) : [];
          this.customerPayload.businessList = customerSelected.map(x=>x.businessId);
          this.getBusinessCustomers();
        }

        // member network interaction
        if(data.formData.source[0].memberNetworksCandidates != this.customerPayload.memberNetworkChosen){
          this.setToDefaulFilter("CUSTOMER");
          this.customerPayload.memberNetworkChosen = data.formData.source[0].memberNetworksCandidates;
          this.getBusinessCustomers('MEMBER_NETWORK');
        }

        // member and personal network interaction
        if(JSON.stringify(data.personalNetworks) != JSON.stringify(this.publishedPayload.personalNetworks)){
          this.setToDefaulFilter();
          this.publishedPayload.memberNetworkChosen = data.formData.source[0].memberNetworksCandidates;
          this.publishedPayload.personalNetworks = data.personalNetworks === undefined ? [] : data.personalNetworks;
          this.publishedPayload.users = publishedSelected.map(x=>x.userId);
          this.getPublishedBy();
        }

        this.customerPrevSelectedValue = customerSelected;
        this.publishedByPrevSelectedValue =  publishedSelected;
        this.businessNetworkPrevSelectedValue =  data.businessNetworkSelectedData === undefined ? [] : data.businessNetworkSelectedData;

        if(this.businessNetworkPrevSelectedValue.length > 0){
          setTimeout(() => {
            this.businessNetworkData = this.businessNetworkPrevSelectedValue;
           }, 1000);
        }

      }


    }
  }

  ngAfterViewInit(): void {
    if (this.benchNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceCandidates').patchValue(false);
      this.jobSourcesFormarray.at(0).get('benchNetworkCandidates').patchValue(true);
    } else if (this.mtaNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceCandidates').patchValue(false);
      this.jobSourcesFormarray.at(0).get('mtaNetworkCandidates').patchValue(true);
    } else if (this.freelancerNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceCandidates').patchValue(false);
      this.jobSourcesFormarray.at(0).get('freeLancerNetworkCandidates').patchValue(true);
    } else if (this.jobseekerNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceCandidates').patchValue(false);
      this.jobSourcesFormarray.at(0).get('jobSeekerNetworkCandidates').patchValue(true);
    }
  }

  ngOnInit(): void {
    this.previousSearchAfterKey1 = null;
    this.datas.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.stopscrollFlag = false;
    this.getCountries();
    this.getSubmissionFilter();
  }


  getCandidateSource() {

    // Full-panel overlay while the filter opens and its structural data loads.
    // Cleared once the Source data is in and the dropdown fetches are kicked
    // off — from then on each dropdown shows its own scoped spinner.
    this.isLoading = true;
    this.gigsumoService.getFilterELement("CANDIDATE" , this.userIdStorage).subscribe(async response=>{
      if(response.code === GigsumoConstants.SUCESSCODE){

        this.businessNetworkData =  response.data.businessNetworks;
        this.tempBusinessNetworks = this.businessNetworkData;
        this.memberNetworks =  response.data.memberNetworks;
        this.personalNetworks = response.data.personalNetworks.map(r=>{
        let data = GigsumoService.FILTER_ITEMS("CANDIDATE").find(x => x.value === r.networkName);
          if(data){
            r.key = data.key;
          }
          else{
            r.key = r.networkId;
          }
          return r;
        });

        this.jobsoucefilterFrom(this.personalNetworks);

        // SuperAdmin Talent Center: pre-tick "My Talents" (myCandidates)
        // and "My Employees" so the filter slider opens with these
        // defaults visible. Gated to !hideCandidateSource so Talent
        // Pool (where the Talent Source section is hidden entirely)
        // doesn't auto-tick anything. Listing API isn't auto-applied —
        // user clicks Apply to filter. The myEmployees emit kicks off
        // the picker's employee fetch so the dropdown is populated
        // when the user expands it.
        if (this.orgCandidatesMode && !this.hideCandidateSource) {
          const src = this.jobSourcesFormarray.at(0);
          if (src) {
            src.get('myCandidates')?.patchValue(true);
            src.get('myEmployees')?.patchValue(true);
            this.myEmployeesToggled.emit();
          }
        }

        // SuperAdmin Talent Center: pre-tick every Status checkbox (All,
        // Available, Draft, Unavailable) so the listing isn't restricted
        // by status out of the box. Gated to !hideStatus so Talent Pool
        // (where Status is hidden) doesn't tick invisible boxes. Matches
        // the pre-tick treatment of "My Talents" + "My Employees" above.
        if (this.orgCandidatesMode && !this.hideStatus) {
          this.statusCheckboxes.forEach(item => { item.selected = true; item.disable = false; });
        }

        this.getPublishedBy();

        if(this.businessNetworkData ||  this.memberAvailable){
          this.customerPayload.businessNetworks = [];
          this.customerPayload.businessId = localStorage.getItem("businessId");
          await pauseForSeconds(500);
          this.setToDefaulFilter("CUSTOMER");
          this.getBusinessCustomers(this.memberAvailable ? "MEMBER_NETWORK" : "BUSINESS-NETWORK");
        }
        // Structural load done + dropdown fetches kicked off; drop the overlay
        // so the per-dropdown spinners take over.
        this.isLoading = false;
      }
      else{
        this.isLoading = false;
      }
    }, () => {
      this.isLoading = false;
    });

  }


  publishedByList = new BehaviorSubject<any[]>([]);
  getPublishedBy() {

      this.publishedByLoading = true;
      this.publishedPayload.all = this.jobSourcesFormarray.at(0)!=undefined && this.jobSourcesFormarray.at(0).get('all').value;
      this.apiService.create("business/findNetworkConnections", this.publishedPayload).subscribe(response=>{
          if(response.code === GigsumoConstants.SUCESSCODE){
            const users = response.data.connectionsList;
            const searchKey = response.data.searchAfterKey;

            if (users) {
              const current = users;
              const exist = this.publishedByList.getValue();
              if(this.publishedByPrevSelectedValue && this.publishedByPrevSelectedValue.length > 0){
                const retainUser = response.data.usersToRetain;
                if(retainUser === undefined){
                  this.publishedByPrevSelectedValue = [];
                }
                else if(retainUser){
                  this.publishedByPrevSelectedValue = this.publishedByPrevSelectedValue.filter(x => retainUser.includes(x.userId));
                }
                this.selectedPublishedBy = this.publishedByPrevSelectedValue.map(x => x.userId);
                this.updateFunction();
              }
              let data = (this.publishedByPrevSelectedValue &&
              this.publishedByPrevSelectedValue.length > 0) ? exist.concat(this.publishedByPrevSelectedValue)
              : exist;
              let finalData = this.gigsumoService.removeDuplicatesKey([...data, ...current] , 'userId');
              this.publishedByList.next(finalData);
            }

            if (
              users != null && (users.length === 0 || JSON.stringify(this.publishedByPrevSearchAfterKey) ===  JSON.stringify(searchKey))
            ) {
              this.publishedByStopScroll = true;
            }

            this.publishedByPrevSearchAfterKey = searchKey;
          }
          this.publishedByLoading = false;
      }, () => {
          this.publishedByLoading = false;
      });

  }

  customersList = new BehaviorSubject<any[]>([]);
  async getBusinessCustomers(from : string = "BUSINESS-NETWORK", mode : 'replace' | 'scroll' | 'global' = 'replace') {

    if((this.membershipType == "Growth" || this.membershipType == "Starter"||this.membershipType == "ScaleX") || from === 'MEMBER_NETWORK' ){
      // global  = Business Network pick → full-panel overlay.
      // scroll  = pagination → bottom spinner, list stays put.
      // replace = open/search → full-body spinner in the Customer dropdown.
      if(mode === 'global'){ this.isLoading = true; }
      else if(mode === 'scroll'){ this.customerLoadingMore = true; }
      else { this.customerLoading = true; }
      this.customerPayload.businessId = this.businessId;
       this.apiService.create("business/findBusinessCustomers", this.customerPayload).subscribe(response=>{
        if(response.code === GigsumoConstants.SUCESSCODE){

          const users = response.data.businessDetails;
          const searchKey = response.data.searchAfterKey;

          if (users) {
            const current = users;
            const exist = this.customersList.getValue();
            if(this.customerPrevSelectedValue && this.customerPrevSelectedValue.length > 0){
              const retainUser = response.data.businessesToRetain;
              if(retainUser === undefined){
                this.customerPrevSelectedValue = [];
              }
              else if(retainUser){
                this.customerPrevSelectedValue = this.customerPrevSelectedValue.filter(x => retainUser.includes(x.businessId));
              }
              this.selectedCustomers = this.customerPrevSelectedValue.map(x=> x.businessId);
              this.updateFunction();

            }
            let data = (this.customerPrevSelectedValue  &&
            this.customerPrevSelectedValue.length > 0) ? exist.concat(this.customerPrevSelectedValue)
            : exist;
            let finalData = this.gigsumoService.removeDuplicatesKey([...data, ...current] , 'businessId');
            this.customersList.next(finalData);
          }

          if (
            users != null && (users.length === 0 || JSON.stringify(this.customersPrevSearchAfterKey) ===  JSON.stringify(searchKey))
          ) {
            this.customersStopScroll = true;
          }

          this.customersPrevSearchAfterKey = searchKey;
        }
        this.customerLoading = false;
        this.customerLoadingMore = false;
        this.isLoading = false;
      }, () => {
        this.customerLoading = false;
        this.customerLoadingMore = false;
        this.isLoading = false;
      });
    }
    else{
      // Membership tier makes this a no-op (no Customer reload). Make sure a
      // network-select that armed the loaders doesn't leave them stuck.
      this.customerLoading = false;
      this.customerLoadingMore = false;
      this.isLoading = false;
    }
  }

  isSelectedField(c : keyof CandidateVerticalFilterTemplateComponent) : boolean{
    return c === "selectedPublishedBy" || c === "selectedCustomers" || c === "selectedBusinessNetworks" || c === "selectedEmployees";
  }

  selectedSubmission = [];
  selectedPublishedBy = [];
  selectedCustomers = [];
  selectedBusinessNetworks = [];
  selectedEmployees: string[] = [];
  employeeList = new BehaviorSubject<any[]>([]);
  employeePrevSelectedValue: any[] = [];
  customerPrevSelectedValue = [];
  publishedByPrevSelectedValue = [];
  businessNetworkPrevSelectedValue = [];
  onSelectChange(data : any[] , content){
    // Clear the instant spinner the picker armed on tick. Selecting a
    // Customer / Published By value triggers no reload, so its scoped flag
    // must go back off here; the Business Network branch below re-arms the
    // GLOBAL overlay because a network pick reloads both lists.
    this.isLoading = false;
    this.publishedByLoading = false;
    this.customerLoading = false;
    if(data && this.isSelectedField(content)){
      const key =
      content === "selectedCustomers" ?  "businessId" :
      content === "selectedBusinessNetworks" ? "b2bNetworkId" :
      content === "selectedEmployees" ? "userId" :
      "userId";

      this[content] = data.filter(x => x.enabled === true).map(c => c[key]);

      if(content === "selectedCustomers"){
        this.customerPrevSelectedValue = data.filter(x => x.enabled === true);
        this.customerPayload.businessList = this.selectedCustomers;
        const datas = this.customersList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.customersList.next(datas);
      }
      else if(content === "selectedPublishedBy"){
        this.publishedByPrevSelectedValue = data.filter(x => x.enabled === true);
        this.publishedPayload.users = this.selectedPublishedBy;
        const datas = this.publishedByList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.publishedByList.next(datas);
      }
      else if(content === "selectedEmployees"){
        this.employeePrevSelectedValue = data.filter(x => x.enabled === true);
        const datas = this.employeeList.getValue().sort((x, y) => (x.enabled === y.enabled) ? 0 : x.enabled ? -1 : 1);
        this.employeeList.next(datas);
      }
      else if(content === "selectedBusinessNetworks"){
        this.selectedBusinessNetworks = this.selectedBusinessNetworks.length === 0 ?
        this.allBusinessNetwork : this.selectedBusinessNetworks;
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworks = this.selectedBusinessNetworks;
        // A network pick reloads both lists → show the global panel overlay.
        // getBusinessCustomers clears it when it returns.
        this.isLoading = true;
        this.getBusinessCustomers("BUSINESS-NETWORK", 'global');
        this.businessNetworkPrevSelectedValue = data;
      }


      this.updateFunction();
    }
  }


  getSubmissionFilter() {
    this.apiService.create('listvalue/findbyList' , {domain : "JOB_APPLICATION_SUPPLIER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS"}).subscribe(res=>{
        const sorted : Array<any> =  res.data.JOB_APPLICATION_SUPPLIER_ACTIONS && res.data.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems;
        // this.filterApplicantData = res.data;
        if(sorted){
          this.submissionFilter = sorted.map(x => {
            const d = {itemId : x.itemId , label : x.value , selected : false , disable : false }

            if(this.selectedSubmission){
              const found = this.selectedSubmission.find(x => x === d.itemId);
              if(found){
                d.selected = true
              }
            }

            return d;
          });
        }
     });
  }

  onExperienceValueChange() {
    let selectedValue: any;
    selectedValue = this.candidateFilterForm.get('experienceType').value;
    if (selectedValue == GigsumoConstants.EXPERIENCE_JUNIOR) {
      this.candidateFilterForm.patchValue({ experienceFrom: 1, experienceTo: 3 });
    } else if (selectedValue == GigsumoConstants.EXPERIENCE_MID_LEVEL) {
      this.candidateFilterForm.patchValue({ experienceFrom: 4, experienceTo: 6 });
    } else if (selectedValue == GigsumoConstants.EXPERIENCE_SENIOR) {
      this.candidateFilterForm.patchValue({ experienceFrom: 6, experienceTo: 10 });
    } else if (selectedValue == GigsumoConstants.EXPERIENCE_ARCHITECT) {
      this.candidateFilterForm.patchValue({ experienceFrom: 10, experienceTo: 20 });
    } else {
      this.candidateFilterForm.patchValue({ experienceFrom: null, experienceTo: null });
    }
    this.updateFunction();
  }

  onPostedDaysChange() {
    let selectedValue: any;
    selectedValue = this.candidateFilterForm.get('postedDayRange').value;
    if (selectedValue == GigsumoConstants.POSTED_TODAY) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 1 });
    } else if (selectedValue == GigsumoConstants.POSTED_LAST_7_DAYS) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 7 });
    } else if (selectedValue == GigsumoConstants.POSTED_LAST_14_DAYS) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 14 });
    } else if (selectedValue == GigsumoConstants.POSTED_LAST_30_DAYS) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 30 });
    } else {
      this.candidateFilterForm.patchValue({ postedFrom: null, postedTo: null });
    }
    this.updateFunction();
  }

  ngOnDestroy(): void {
    if (this.filterSubscriber) {
      this.filterSubscriber.unsubscribe();
    }
  }


  updateCandidateFilterData() {
    const userType = localStorage.getItem('userType') as USER_TYPE;

    if (this.isMTAorFREEandBENCHorJob(userType)) {
      this.owner = true;
    }
    else if (this.isRecruiter(userType)) {
      this.owner = false;
    }

  }

  setDefaultFilter(value: string) {
    this.candidateSource.push(value);
    this.getSource().at(0).get(value).patchValue(true);
    if (this.candidateFilterData) {
      this.candidateFilterData.clickHandler.apply(this.candidateFilterData.source, [
        { formData: this.candidateFilterForm.getRawValue(), content: "DEFAULT" }
      ]);
    }
  }

  getSource(): UntypedFormArray {
    return this.candidateFilterForm.get('source') as UntypedFormArray;
  }

  isRecruiter(userType): boolean {
    return userType === GigsumoConstants.RECRUITER;
  }

  isBenchorJob(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.BENCH_RECRUITER
      || userType === GigsumoConstants.JOB_SEEKER);
  }

  isMTAorFREEandBENCHorJob(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.JOB_SEEKER
      || userType === GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.BENCH_RECRUITER);
  }

  isMTAorFREE(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.FREELANCE_RECRUITER);
  }

  onLoad() {
    this.ScreenLoadBool = true;
    let data: any = JSON.parse(localStorage.getItem('candidateForm'));
    this.generateWorkAutorization(data.country);

    for (let key in data.source) {
      if (data.source[key] === true) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.candidateSource.push(key)

        this.candidateSource.forEach((ele, index) => {
          if (this.FeaSugg && ele === "featured" || this.FeaSugg && ele === "suggestedCandidates") {
            this.candidateSource.splice(index, 1)
          }
          if (!this.owner && ele === "myCandidates") {
            this.candidateSource.splice(index, 1)
          }
        })

      }
    }
    data.availableIn.forEach((res) => {
      this.availablecheckbox.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res)
        }
      });

    });
    data.status.forEach((res) => {
      this.statusCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res)
        }
      });
    });
    data.engagementType.forEach((res) => {
      this.availableForCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res)
        }
      });
    });




    for (let key in data.workType) {
      if (data.workType[key] === true) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.candidateSource.push(key)
      }
    }
    this.candidateSource = [...new Set(this.candidateSource)]
    this.candidateSource.forEach((ele, index) => {
      if (ele === "All" || ele === "all") {
        this.candidateSource.splice(index, 1)
      }
    });

    this.value = data.experienceFrom != null ? data.experienceFrom : 0;
    this.highValue = data.experienceTo != null ? data.experienceTo : 0;
    this.value1 = data.postedFrom != null ? data.postedFrom : 0;
    this.highValue1 = data.postedTo != null ? data.postedTo : 0;

    this.candidateFilterForm.get('country').patchValue(data.country)
    this.candidateFilterForm.get('state').patchValue(data.state)
    this.candidateFilterForm.get('city').patchValue(data.city)
    this.candidateFilterForm.get('zipCode').patchValue(data.zipCode)
    setTimeout(() => {
      data.workAuthorization.forEach((res) => {
        this.WACheckboxes.forEach(item => {
          if (item.label === res) {
            this.showWorkAuthorization = true
            item.selected = true;
            this.candidateSource.push(res)
          }
        });
      });
    }, 1000);


    this.datas = data
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);

    this.previousSearchAfterKey1 = null;
    this.datas.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.stopscrollFlag = false;

    localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
    this.apicallfilter();
  }

  getCredits(val) {

    if (val != null && this.creditsConsume == null) {
      this.creditsConsume = val;
    }
    else if (val != null && this.creditsConsume != null) {
      this.creditsConsume = "";
      this.creditsConsume = val;
    }

  }

  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.apiService.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  invalidDate(valid: boolean) {
    this.valid = valid;
  }
  settingUpFilters() {
    if (!this.jobfilter) {
      if (!this.isMyCandidateShowedOnLoad && !this.networkflag && this.candiSourceSearchRoute == null) {
        this.totalFilters = 1
        this.candidateSource.push('marketPlaceCandidates');
        this.candidateSource = [...new Set(this.candidateSource)];
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceCandidates').patchValue(true);
        this.applyFilternew()
      } else if (this.isMyCandidateShowedOnLoad && this.owner && !this.networkflag && this.candiSourceSearchRoute == null) {
        this.totalFilters = 1
        this.candidateSource.push('myCandidates');
        this.candidateSource = [...new Set(this.candidateSource)];
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);
        this.applyFilternew()
      } else if (this.networkflag) {
        this.candidateSource.push(this.candiSourceSelectNetRoute)
        this.candidateSource = [...new Set(this.candidateSource)]
        this.datas.searchAfterKey = null;
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(this.candiSourceSelectNetRoute).patchValue(true);
        this.applyFilternew();
      } else if (this.candiSourceSearchRoute != null) {
        this.candidateSource = []
        this.candidateSource.push(this.candiSourceSearchRoute)
        this.candidateSource = [...new Set(this.candidateSource)]
        this.datas.searchAfterKey = null;
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(this.candiSourceSearchRoute).patchValue(true);
        this.applyFilternew();
      } else {
        this.totalFilters = 0
        this.candidateSource.push('benchNetworkCandidates')
        this.candidateSource = [...new Set(this.candidateSource)];
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').patchValue(true);
        this.applyFilternew()
      }

    } else if (this.jobfilter) {
      this.totalFilters = 0
      this.applyFilternew();

      //   disable for filter
      for (let key of this.keyarrayCandidatesouces) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).disable();
      }

      for (let key of this.keysarrWorks) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).disable();
      }
      this.availableForCheckboxes.forEach(item => item.disable = true);
      this.statusCheckboxes.forEach(item => item.disable = true);
      this.WACheckboxes.forEach(item => item.disable = true);
      this.availablecheckbox.forEach(item => item.disable = true);


    }
  }

  receiveDataFromAccordion(data: any) {
    // Handle the data received from the accordion component
  }

  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }

  // cancelApplication() {
  //   this.router.navigate(['newjobs'])
  // }

  // cancelFilterValues() {

  //   this.statusFlag = false
  //   this.countryFlag = false
  //   this.totalExperienceFlag = false
  //   this.benchCandidatesFlag = false
  //   this.remoteWorkFlag = false
  //   this.postedInDaysFlag = false
  //   this.experienceToFlag = false
  //   this.experienceFromFlag = false
  //   this.cityFlag = false
  //   this.zipcodeFlag = false
  //   this.workFromHomeFlag = false
  //   this.stateFlag = false
  //   this.relocationRequiredFlag = false
  //   this.engagementTypeFlag = false
  //   this.workAuthorizationFlag = false
  //   this.featuredCandidatesFlag = false
  //   // this.suggestedCandidatesFlag = false
  //   this.lgModal.hide()
  //   this.resetFilter()
  //   this.filterOn = false
  //   this.obj.searchAfterKey = null
  //   if (this.owner) {
  //     this.myCandidateFlag = true
  //     this.applyFilter('manual', null)
  //   } else {
  //     this.myCandidateFlag = false
  //     this.getCandidateList("candidates/findCandidates")
  //   }


  //   this.getchildData(null)
  // }

  // get child date to display widgets
  getchildData(data) {
    if (data != null) {
      this.dataPasstoSkillwidgets = JSON.parse(data);
    } else {
      this.dataPasstoSkillwidgets = [];

    }
  }

  //  user remove after uncheck from widgets
  removeUserfromTag(data) {
    this.removeTagvalues = data;
    this.response.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });

    this.dataPasstoSkillwidgets.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });
  }

  onChangeYear(value) {
    if (value.highValue > 0) {
      this.yearApplied = true
    } else if (value.highValue == 0) {
      this.yearApplied = false
    }
    this.candidateFilterForm.get('experienceFrom').patchValue(value.value);
    this.candidateFilterForm.get('experienceTo').patchValue(value.highValue);
    this.response = []

    this.previousSearchAfterKey1 = null;

    this.datas.searchAfterKey = null
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
    this.updateFunction();
  }

  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }
  onChangepostday(value, param?: any) {
    if (value.highValue > 0) {
      this.postDateApplied = true
    } else if (value.highValue == 0) {
      this.postDateApplied = false
    }
    this.candidateFilterForm.value.postedFrom = value.value
    this.candidateFilterForm.value.postedTo = value.highValue
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew(param);
    this.updateFunction();
  }

  applyFilternew(param?: any) {
    return;
    console.log(param)
    this.stopscrollFlag = false;
    this.datas.searchAfterKey = null;

    if (this.jobfilter) {
      this.candidateFilterForm.value.jobId = this.filterdata.jobId
    }

    var statusCheckboxesUpdate: any = [];
    this.statusCheckboxes.forEach(element => {
      if (element.selected) {
        statusCheckboxesUpdate.push(element.label)
      }
    });

    var clientTypeCheckboxesUpdate: any = [];
    this.WACheckboxes.forEach(element => {
      if (element.selected) {
        clientTypeCheckboxesUpdate.push(element.label)
      }
    });

    var jobClassificationUpdate = [];
    this.availableForCheckboxes.forEach(element => {
      if (element.selected) {
        jobClassificationUpdate.push(element.label)
      }
    });

    var avalables = [];
    this.availablecheckbox.forEach(element => {
      if (element.selected) {
        avalables.push(element.label)
      }
    });
    var submissionFilters = [];
    this.candidate_status.forEach(element => {
      if (element.selected) {
        let value = element.label;
        if (value == "Pre-Onboarding") {
          value = "PREONBOARDED";
        }
        submissionFilters.push(value.toLocaleUpperCase())
      }
    });

    this.candidateFilterForm.value.workAuthorization = clientTypeCheckboxesUpdate; // work auth values
    this.candidateFilterForm.value.availableIn = avalables;
    this.candidateFilterForm.value.engagementType = jobClassificationUpdate;
    this.candidateFilterForm.value.status = statusCheckboxesUpdate;
    this.candidateFilterForm.value.submissionFilters = submissionFilters;
    this.candidateFilterForm.value.userId = localStorage.getItem('userId')
    if (this.previousSearchAfterKey1 != null || this.previousSearchAfterKey1 != undefined) {
      this.candidateFilterForm.value.searchAfterKey = this.previousSearchAfterKey1;
    } else {
      this.candidateFilterForm.value.searchAfterKey = null;
    }

    if (!this.jobfilter) {
      this.datas = {
        source: this.candidateFilterForm.value.source[0],
        workType: this.candidateFilterForm.value.workType[0]
      };
    }

    if (this.jobfilter) {
      this.datas.jobId = this.candidateFilterForm.value.jobId
      this.datas.source = {
        all: false,
        myCandidates: true,
        marketPlaceCandidates: false,
        teamCandidates: false,
        benchNetworkCandidates: false,
        freeLancerNetworkCandidates: false,
        mtaNetworkCandidates: false,
        jobSeekerNetworkCandidates: false,
        featured: false,
        suggestedCandidates: false
      }
      this.datas.workType = {
        all: false,
        remoteWork: false,
        relocationRequired: false,
        workFromHome: false
      }
    } else {
    }

    this.datas.workAuthorization = clientTypeCheckboxesUpdate,
      this.datas.engagementType = jobClassificationUpdate,
      this.datas.availableIn = avalables,
      this.datas.status = statusCheckboxesUpdate,
      this.datas.searchAfterKey = this.candidateFilterForm.value.searchAfterKey,
      this.datas.city = this.candidateFilterForm.value.city,
      this.datas.state = this.candidateFilterForm.value.state,
      this.datas.country = this.candidateFilterForm.value.country,
      this.datas.zipCode = this.candidateFilterForm.value.zipCode,
      this.datas.submissionFilters = this.candidateFilterForm.value.submissionFilters,
      // this.datas.totalExperience = this.candidateFilterForm.value.totalExperience
      this.datas.experienceFrom = this.candidateFilterForm.value.experienceFrom;
    this.datas.experienceTo = this.candidateFilterForm.value.experienceTo;
    this.datas.postedFrom = this.candidateFilterForm.value.postedFrom
    this.datas.postedTo = this.candidateFilterForm.value.postedTo
    this.datas.limit = this.candidateFilterForm.value.limit,
      this.datas.userId = this.candidateFilterForm.value.userId
    this.datas.searchContent = this.searchContent;
    delete this.datas.searchContent;

    if (this.searchContent != "" && this.searchContent != undefined) {
      this.datas.searchContent = this.searchContent;
      this.datas.searchAfterKey = null;
    }


    if (this.candidateSource.length > 0 && this.searchContent == ""
      || this.candidateSource.length > 0 && this.searchContent == undefined) {
      localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
      localStorage.setItem('candidateForm', JSON.stringify(this.datas));
    }

    if (this.candidateSource.length == 0) {
      this.stopscrollFlag = false;
      localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
      localStorage.setItem('candidateForm', JSON.stringify(this.datas));
    } else if (this.searchContent != "" && this.searchContent != undefined) {
      this.response = [];
      // this.commonvalues.setcandidateData(this.response);
      localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
      localStorage.setItem('candidateForm', JSON.stringify(this.datas));
    } else {
      if (this.networkflag) {
        localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
        localStorage.setItem('candidateForm', JSON.stringify(this.datas));
      }
    }
  }


  @Output() valuesRetainedForFilters = new EventEmitter<any>(null);
  startFilter() {
    let data: any = {}
    const candidateSource = JSON.parse(localStorage.getItem('candidateSource'))
    const candidateForm = JSON.parse(localStorage.getItem('candidateForm'))
    data.candidateSource = candidateSource;
    data.candidateForm = candidateForm
    const jsonData = JSON.stringify(data);
    this.panelValue.emit('candidates')
    this.valuesRetainedForFilters.emit(jsonData);
  }

  searchfilter() {
    // if(this.searchContent.length!=0){
    this.response = [];
    this.previousSearchAfterKey1 = null;
    this.datas.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.stopscrollFlag = false;
    window.scrollTo(0, 0);
    this.applyFilternew();
  }

  apicallfilter() {
    this.util.startLoader()
    this.searchData.getcandidateCount().subscribe(res => {
      if (res != 0 && res.flag) this.stopscrollFlag = false;
      if (res != 0 && res.flag && res.status === "ACTIVE") {
        this.totalCandidatesCount += res.count;
      }
      else if (res != 0 && !res.flag || res != 0 && res.flag && res.status != "ACTIVE") {
        this.totalCandidatesCount = res.count;
      }
    });
    localStorage.setItem('candidateForm', JSON.stringify(this.datas))
  }

  onChangeCountry(event) {
    this.candidateFilterForm.get('city').patchValue(null)
    this.candidateFilterForm.get('state').patchValue(null)
    this.candidateFilterForm.get('zipCode').patchValue(null)
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
    const countryCode = event;

    if (event == "US") {
      if (this.usStatesList.length == 0) {
        // this.usStatesList = [];
        // if (this.usStatesList.length == 0) {
        this.apiService
          .query("country/getAllStates?countryCode=" + countryCode)
          .subscribe((res) => {
            res.forEach(ele => {
              this.usStatesList.push(ele.stateName)
            })
          }, err => {
            this.util.stopLoader();
          });
        // }
      }
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListAU = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListIN = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListCA = res;
        }, err => {
          this.util.stopLoader();
        });
    }

    this.generateWorkAutorization(countryCode);
    this.updateFunction();
  }

  generateWorkAutorization(countryCode: string) {
    // Snapshot any currently-selected WA labels BEFORE we swap the picker.
    // workAuthcheckbox dual-writes: it flips WACheckboxes[i].selected AND
    // pushes the label into candidateSource. When the country changes the
    // WACheckboxes get replaced but candidateSource (and a no-WA country's
    // stale WACheckboxes) carry over and ride along on the next Apply.
    const previouslySelectedWa = (this.WACheckboxes || [])
      .filter(x => x.label !== 'All' && x.selected === true)
      .map(x => x.label);

    this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_' + countryCode).subscribe(res => {
      if (res != undefined && res.code == '00000' && res.data.listValues.length > 0) {
        this.showWorkAuthorization = true
        this.WACheckboxes = []
        this.WACheckboxes = [{ label: 'All', selected: false, disable: false }]
        this.util.stopLoader()
        this.usStatesList = []
        res.data.listValues[0].listItems.forEach((ele) => {
          this.WACheckboxes.push({ label: ele.item, selected: false, disable: false })

        })

      }
      else {
        this.showWorkAuthorization = false
        // Org page only: also drop the cached WA options so a country-
        // without-WA doesn't leave stale `selected=true` items in
        // WACheckboxes that ride along in payload.workAuthorization on the
        // next Apply. Non-org template paths left unchanged.
        if (this.orgCandidatesMode) {
          this.WACheckboxes = []
        }
      }

      // Org page only: scrub WA labels that workAuthcheckbox pushed into
      // candidateSource for the previous country, so they don't keep
      // filtering after the country was changed/cleared. Non-org left alone.
      if (this.orgCandidatesMode && previouslySelectedWa.length && Array.isArray(this.candidateSource)) {
        this.candidateSource = this.candidateSource.filter(x => !previouslySelectedWa.includes(x));
        this.ischeckedClientType = false;
      }

    });
  }

  onChangestate(state) {
    this.candidateFilterForm.value.state = state;
    this.response = [];
    this.previousSearchAfterKey1 = null;
    // this.commonvalues.setcandidateData(this.response);
    // Clear City/ZIP only when State was chosen from a dropdown (CA/IN/AU).
    // For free-text State countries the user types both City and State, so
    // nothing should be wiped. (orgCandidatesMode still scopes the remove guard.)
    const stateFromDropdown = ['CA', 'IN', 'AU'].indexOf(this.candidateFilterForm.value.country) > -1;
    if (stateFromDropdown && (state || !this.orgCandidatesMode)) {
      this.candidateFilterForm.get('city').patchValue(null)
      this.candidateFilterForm.get('zipCode').patchValue(null)
    }
    this.updateFunction();
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
  }

  onChangecity(city) {

    this.response = [];
    this.previousSearchAfterKey1 = null;

    // this.commonvalues.setcandidateData(this.response);
    this.candidateFilterForm.value.city = city;
    // Scope the "don't clear on remove" guard to SuperAdmin Talent
    // Center / Talent Pool (orgCandidatesMode) only. Regular Candidate
    // page keeps the original cascade-clear behaviour.
    if (city || !this.orgCandidatesMode) {
      this.candidateFilterForm.get('zipCode').patchValue(null)
    }
    this.updateFunction();
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
  }

  onChangezipcode(zipCode) {
    this.response = [];
    this.previousSearchAfterKey1 = null;
    // this.commonvalues.setcandidateData(this.response);
    this.candidateFilterForm.value.zipCode = zipCode;
    this.updateFunction();
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
  }

  resetFilternew() {
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;
    this.showWorkAuthorization = false;

    if (this.candidateFilterForm != undefined) {
      this.candidateFilterForm.get('state').patchValue(null)
      this.candidateFilterForm.get('country').patchValue(null)
      this.candidateFilterForm.get('city').patchValue(null)
      this.candidateFilterForm.get('zipCode').patchValue(null)


      this.WACheckboxes.forEach(item => item.selected = false);  // cleint type -- work auth
      this.statusCheckboxes.forEach(item => item.selected = false);
      this.availableForCheckboxes.forEach(item => item.selected = false);
      this.availablecheckbox.forEach(item => item.selected = false);
      this.candidate_status.forEach(item => item.selected = false);


      for (let key of this.keyarrayCandidatesouces) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }

      for (let key of this.keysarrWorks) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }
      this.candidateSource = ['myCandidates'];
      if (this.owner && this.isMyCandidateShowedOnLoad) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);
      } else if (!this.isMyCandidateShowedOnLoad) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceCandidates').patchValue(true);
      }
      this.obj1.searchAfterKey = null;
      this.applyFilternew();
    }
  }

  openFilter() {
    this.filterOn = true
  }

  createCandidateFilterForm() {
    this.candidateFilterForm = this.formBuilder.group({
      source: this.formBuilder.array([]),
      workMode: [],
      availableIn: null,
      engagementType: null,
      status: null,
      submissionFilters: null,
      //work auth
      workAuthorization: null,
      searchAfterKey: null,

      // engagementType: null,
      // workAuthorization: null,
      // jobId: null,
      // benchSalesCandidates: null,
      country: null,
      userId: localStorage.getItem('userId'),
      state: null,
      city: null,
      zipCode: null,
      limit: 10,
      resetFilter : false,
      // searchAfterKey: null,
      // relocationRequired: false,
      // remoteWork: false,
      // workFromHome: false,
      // postedInDays: null,
      totalExperience: null,
      postedFrom: null,
      postedTo: null,
      experienceFrom: null,
      // benchCandidates: false,
      experienceTo: null,
      // myCandidates: true,
      //  isFeatured: false,
      // featuredCandidates:false
      experienceType: 'Any (Years)',
      postedDayRange: 'Any (Days)'

    });


  }

  jobsoucefilterFrom(d) {
    this.jobSourcesFormarray.push(this.candidateService.candidateSourcefields(d));
    this.candidateFilterForm.patchValue(this.filterFormData);
  }

  get jobSourcesFormarray() {
    return this.candidateFilterForm.get('source') as UntypedFormArray;
  }

  jobSourcefields(): UntypedFormGroup {
    return this.formBuilder.group({
      all: false,
      myCandidates: false,
      marketPlaceCandidates: false,
      teamCandidates: false,
      benchNetworkCandidates: false,
      freeLancerNetworkCandidates: false,
      mtaNetworkCandidates: false,
      jobSeekerNetworkCandidates: false,
      featured: false,
      suggestedCandidates: false,
      businessNetwork : false,
      memberNetworksCandidates : false,
    });
  }



  onKeyZip(event: any) {
    let data: any = {};
    data.countryCode = "US";
    data.zipCode = event.target.value;
    data.stateCode = "";
    if (data.zipCode.length === 5) {
      // Capture the ZIP we're requesting so we can detect if the user
      // edits the field while the geo call is in flight.
      const requestedZip = data.zipCode;
      this.apiService.create("country/geodetails", data).subscribe((res) => {
        // Guard against the race condition where the user backspaces
        // (12390 → 123) between the geo request and its response — see
        // the same guard in job-filter-vertical-template.onKeyZip for
        // the full rationale.
        if (this.candidateFilterForm.value.zipCode !== requestedZip) {
          return;
        }
        if (
          res &&
          res != null &&
          res != "" &&
          res.length > 0 &&
          event.target.value != ""
        ) {
          res.forEach((ele) => {
            let cityName = ele.cityName;
            let stateName = ele.stateName;
            this.candidateFilterForm.patchValue({
              city: cityName,
              state: stateName,
            });
          });
          // City and state inputs are `disabled` for US, so they can only
          // be filled in via this geo lookup. Without notifying the parent
          // here, the parent's tempFilterChanges keeps stale null values
          // and Apply sends city='' / state='' to the backend — the user
          // ends up filtering by only country+zipCode even though the UI
          // visually shows city/state populated.
          this.updateFunction();
        }
      }, err => {
        this.util.stopLoader();
      });
    } else {
      // ZIP is not a valid 5-digit code (user typed only 1–4 digits, went
      // over 5, or emptied the field entirely). Two things must happen so
      // Apply sends only what's actually in the field right now:
      //   1. Clear the geo-derived city + state. They were filled in by
      //      the previous 5-digit lookup and are now stale — the US
      //      city/state inputs are `disabled`, so the user can't clear
      //      them by hand.
      //   2. Push the fresh snapshot to the parent via updateFunction()
      //      so tempFilterChanges reflects the currently-typed ZIP. Without
      //      this the parent keeps the old snapshot and applyFilter…toPayload
      //      would ship stale zipCode/city/state to the backend.
      // Backend decides matches — no results is fine per the business
      // rule "let the user search anything".
      this.candidateFilterForm.patchValue({ city: null, state: null });
      this.updateFunction();
    }
  }

  reloadFilter(value: string) {
    if (value === 'reload') {
      this.previousSearchAfterKey1 = null;
      this.datas.searchAfterKey = null;
      this.previousSearchAfterKey = null;
      this.obj1.searchAfterKey = null;
      this.applyFilternew();
    }
  }

  // thiru work

  // job souce check uncheck
  // No teamCandidates: Job Seekers have no workspace (checkbox hidden for them).
  JobSeekerRole=[ "all","myCandidates","memberNetworksCandidates","marketPlaceCandidates"];

  jobSoucecheck(event, lable, param?: any) {

    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;

    // SuperAdmin "My Employees" toggle.
    //   ON  → tell parent to fetch findEmployeeList; parent's loading
    //          flag drives the picker's spinner during the call.
    //   OFF → keep the picker mounted briefly with the spinner visible
    //          (matches the on-toggle UX), then let *ngIf hide it.
    //          No API call on off — purely visual feedback.
    if (lable === 'myEmployees' && this.orgCandidatesMode) {
      if (event.target.checked === true) {
        if (this.employeeOffTimer) {
          clearTimeout(this.employeeOffTimer);
          this.employeeOffTimer = null;
        }
        this.employeeOffShowing = false;
        this.employeeOffLoading = false;
        this.myEmployeesToggled.emit();
      } else {
        this.employeeOffShowing = true;
        this.employeeOffLoading = true;
        if (this.employeeOffTimer) clearTimeout(this.employeeOffTimer);
        // 500ms — matches the existing pauseForSeconds(500) used elsewhere
        // in this template for inter-API pauses, so the off-toggle spinner
        // feels consistent with the rest of the filter slider's timings.
        this.employeeOffTimer = setTimeout(() => {
          this.employeeOffShowing = false;
          this.employeeOffLoading = false;
          this.employeeOffTimer = null;
        }, 500);

        // Removing "My Employees" must also drop any employee the user had
        // picked. Otherwise their userId lingers in selectedEmployees and is
        // folded into publishedBy on the next Apply, so their candidates keep
        // showing. Same picker-clearing the Reset handler does above.
        this.selectedEmployees = [];
        this.employeePrevSelectedValue = [];
        const currentEmployees = this.employeeList.getValue();
        if (currentEmployees && currentEmployees.length > 0) {
          this.employeeList.next(currentEmployees.map(item => ({ ...item, enabled: false })));
        }

        // Also refetch findEmployeeList on OFF so the picker's cached data
        // is refreshed (matches the ON behaviour). The parent's
        // onMyEmployeesToggled handler resets the search/pagination state
        // and refires findEmployeeList. Picker stays hidden via *ngIf, so
        // the fresh list is just cached for the next ON toggle.
        this.myEmployeesToggled.emit();
      }
    }
    this.previousSearchAfterKey1 = null;

    if (this.userType === GigsumoConstants.JOB_SEEKER) {
      const sourceFormArray = (this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup;
      const formValues = this.candidateFilterForm.get('source').value;
     if (lable === 'all') {
        this.candidateSource = [];
        this.JobSeekerRole.forEach(key => {
        sourceFormArray.get(key).patchValue(event.target.checked);
        this.candidateSource.push(key);
        });
      } else {
        sourceFormArray.get(lable).patchValue(event.target.checked);
        if (event.target.checked) {
          this.candidateSource.push(lable);
          sourceFormArray.get('all').patchValue(formValues[0].myCandidates && formValues[0].memberNetworksCandidates&& formValues[0].marketPlaceCandidates);
        } else {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
          sourceFormArray.get('all').patchValue(false);
        }
      }

      this.candidateSource = Array.from(new Set(this.candidateSource));
    }


    if (event.target.checked == true && this.userType != GigsumoConstants.JOB_SEEKER) {

      for (let key of this.keyarrayCandidatesouces) {
        if (lable == 'all' && key != 'all') {
          if (key == 'myCandidates' && this.owner && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'teamCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'benchNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'freeLancerNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'mtaNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'jobSeekerNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'featured' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'suggestedCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'marketPlaceCandidates' && this.owner && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        } else {
          if (lable != 'all' && !this.candidateSource.includes(lable)) {
            this.candidateSource.push(lable);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
      }

      if(this.checkIfAllSourceIsSelected()){
        this.jobSourcesFormarray.at(0).get('all').patchValue(true);
      }

    }
    else if (event.target.checked == false && this.userType != GigsumoConstants.JOB_SEEKER) {

      if (lable != 'all') {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(event.target.checked);
      }

      if (lable == 'myCandidates') {
        this.response = []
        this.obj.searchAfterKey = null;
        this.obj1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      if (lable == 'all') {
        for (let key of this.keyarrayCandidatesouces) {
          if (this.candidateSource.includes(key)) {
            this.candidateSource.splice(this.candidateSource.indexOf(key), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
      } else {
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }
    }

    if (lable === 'all' ) {
      let isChecked = event.target.checked;

      if(lable === 'all' && this.userType != GigsumoConstants.JOB_SEEKER){
        this.jobsouceCheckedAll(isChecked);
        if(isChecked){
          this.candidateSource = [];
          Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
            this.candidateSource.push(key);
          });
        }
        else{
          this.candidateSource = [];
        }
      }



      this.setToDefaulFilter();
      this.searchResult = isChecked ? ['Member Network' , 'Personal Networks'] : [];
      this.publishedPayload.personalNetworks = isChecked ? this.allPersonalNetworks : [];
      this.publishedPayload.memberNetworkChosen = isChecked;

      if(this.businessNetworkData && this.businessNetworkData.length > 0){
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworks = isChecked ? this.allBusinessNetwork : [];
        this.getBusinessCustomers();
      }

      this.getPublishedBy();
    }

    let personalNetworkData = [];

    this.candidateSource.forEach(element => {
      this.personalNetworks.forEach(x=>{
          if(x.key === element){
            personalNetworkData.push(x.networkId);
          }
      });
    });

    if(lable === "memberNetworksCandidates"){
      this.setToDefaulFilter("CUSTOMER");
      let isMemberNetworkTrue = this.jobSourcesFormarray.at(0).get(lable).value;
      this.customerPayload.memberNetworkChosen =  isMemberNetworkTrue;
      this.customerPayload.businessNetworks = this.selectedBusinessNetworks === undefined ? [] : this.selectedBusinessNetworks;
      // Member Network source reloads the Customer list — global overlay.
      this.isLoading = true;
      this.getBusinessCustomers("MEMBER_NETWORK", 'global');
    }
    else if(lable === "businessNetwork"){
        this.istempBusinessNetwork = this.jobSourcesFormarray.at(0).get(lable).value;
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworkChosen = this.istempBusinessNetwork;
        this.customerPayload.businessNetworks = event.target.checked ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
        this.selectedBusinessNetworks = this.istempBusinessNetwork ? this.customerPayload.businessNetworks : [];
        this.businessNetworkPrevSelectedValue = [];
        this.businessNetworkData =  this.tempBusinessNetworks.map(x => {
          x.enabled = false;
          return x;
        });
        // Selecting the Business Network source reloads the Customer list —
        // show the global panel overlay while it does.
        this.isLoading = true;
        this.getBusinessCustomers("BUSINESS-NETWORK", 'global');
    }
    else if(param === "personalNetworks"){
      this.setToDefaulFilter();
      this.publishedPayload.personalNetworks = personalNetworkData;
      this.getPublishedBy();
    }

    const isMyCandidatesChecked : boolean  = this.jobSourcesFormarray.at(0) != undefined ? this.jobSourcesFormarray.at(0).get('myCandidates').value : false;
    // Keep Draft enabled in SuperAdmin org-scoped view (orgCandidatesMode)
    // even when only "My Employees" is ticked instead of "My Candidates".
    this.statusCheckboxes = updateStatusCheckBox(this.statusCheckboxes , this.orgCandidatesMode || isMyCandidatesChecked);

    this.updateFunction();
  }

  get allBusinessNetwork() {
    return this.businessNetworkData ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
  }

  get allPersonalNetworks(){
    return this.personalNetworks ? this.personalNetworks.map(x => x.networkId) : [];
  }


  setToDefaulFilter(d = "Published"){
    if(d === "Published"){

      this.publishedPayload.searchAfterKey = null;
      this.publishedByStopScroll = false;
      this.publishedByPrevSearchAfterKey = null;
      this.publishedByList.next([]);
    }
    else{
      this.customerPayload.searchAfterKey = null;
      this.customersStopScroll = false;
      this.customersPrevSearchAfterKey = null;
      this.customersList.next([]);
    }
  }

  // used to sent filter data to parent new-candidate Component on every click
  updateFunction() {
    let personalNetworkData = [];
    if(this.candidateSource){

      this.candidateSource.forEach(element => {
        this.personalNetworks.forEach(x=>{
            if(x.key === element){
              personalNetworkData.push(x.networkId);
            }
        });
      });
    }

    if(this.submissionFilter && this.submissionFilter.filter(x => x.selected === true).length > 0){

      const myCandidateChecked = this.jobSourcesFormarray.at(0).get("myCandidates").value;

      const checkedData =  this.jobSourcesFormarray.controls.map(x =>{
          const d =  Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).
          filter(x => x != 'myCandidates').map(key =>{
              return x.get(key).value;
          });
          return [...d];
      })[0];

      const isAnyChecked = checkedData.some(x => x === true);

      if(myCandidateChecked && isAnyChecked || (this.selectedCustomers.length > 0 || this.selectedPublishedBy.length > 0)){
          this.submissionFilter.forEach(x => x.selected = false);
      }
      else if(!myCandidateChecked){
        this.submissionFilter.forEach(x => x.selected = false);
      }

    }


    const isBusinessNetwork = this.jobSourcesFormarray.at(0)!=undefined && this.jobSourcesFormarray.at(0).get('businessNetwork').value;
    const data  = (this.selectedBusinessNetworks && this.selectedBusinessNetworks.length > 0) ? this.selectedBusinessNetworks : (isBusinessNetwork ? (this.businessNetworkData!= undefined ? this.businessNetworkData.map(x => x.b2bNetworkId) : []) : []) ;

    this.candidateFilterForm.get('resetFilter').patchValue(false);

    if (this.candidateFilterData) {
        this.candidateFilterData.clickHandler.apply(this.candidateFilterData.source,
        [{
          formData: this.candidateFilterForm.getRawValue(),
          workAuthorization: this.WACheckboxes,
          availiabilityCheckedItems: this.availablecheckbox,
          engageMentCheckedItems: this.availableForCheckboxes,
          statusCheckedItems: this.statusCheckboxes,
          checkedItems: this.candidateSource,
          submissionItems: this.submissionFilter,
          from: "VERTICAL",
          personalNetworks : personalNetworkData,
          businessNetworks : data,
          publishedByUsers : this.selectedPublishedBy,
          selectedEmployees : this.selectedEmployees,
          businessCustomers : this.selectedCustomers,
          workMode : this.workModeCheckboxes,
          customerSelectedData : this.customerPrevSelectedValue,
          publishedSelectedData : this.publishedByPrevSelectedValue,
          businessNetworkSelectedData : this.businessNetworkPrevSelectedValue,
          submissionData : this.selectedSubmission
        }]);
    }

  }

  jobsouceCheckedAll(checked) {
    Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
      ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    });
  }

  candiasasrce() {
    this.candidateSourceFlag = !this.candidateSourceFlag
  }

  jobclassifsd() {
    this.jobClassificationFlag = !this.jobClassificationFlag
  }
  availbwelkdfv() {
    this.availableForFlag = !this.availableForFlag
  }

  candidateFlagsd() {
    this.candidateFlag = !this.candidateFlag
  }

  wortjh() {
    this.workAuthFlag = !this.workAuthFlag
  }

  locatioesdnfjh() {
    this.locationFlag = !this.locationFlag
  }
  workefkjhgtyp() {
    this.workTypeFlag = !this.workTypeFlag
  }

  experienfa() {
    this.experienceFlag = !this.experienceFlag
  }

  workTypecheckbox(event, lable) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    if (event.target.checked == true) {
      if (lable == 'all') {
        for (let key of this.keysarrWorks) {
          if (key != 'all' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.workTypecheckboxCheckAll(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }
      }
      // this.filterWhenNoneCandidateSouce();



    }
    else if (event.target.checked == false) {
      if (lable == 'all') {
        for (let key of this.keysarrWorks) {
          if (this.candidateSource.includes(key)) {
            this.candidateSource.splice(this.candidateSource.indexOf(key), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.workTypecheckboxCheckAll(event);
      } else {
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }

      if (lable != 'all') {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(event.target.checked);
      }

    }

    this.updateFunction();
  }

  workTypecheckboxCheckAll(event) {
    const checked = event.target.checked;
    for (let key of this.keysarrWorks) {
      ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    }
  }

  // availableCheckbox check and uncheck
  availabletype(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    // this.commonvalues.setcandidateData(this.response);

    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let allData =[];

    this.availablecheckbox.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label != 'All'){
        allData.push(item);
      }
    });

    if (event.target.checked == true) {
      this.ischeckedJobClassification = true;
      if (lable == 'All') {
        for (let key of this.availablecheckbox) {
          if (key.label != 'All' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.available(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }

      }
      // this.filterWhenNoneCandidateSouce();

      if(allData.every(x=> x.selected == true)){
        this.availablecheckbox[0].selected = true;
      }
    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.availablecheckbox[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.availablecheckbox) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.available(event);
      }
    }

    this.applyFilternew(param);
    this.updateFunction();
  }

  available(event) {
    const checked = event.target.checked;
    this.availablecheckbox.forEach(item => item.selected = checked);
  }

  // availableCheckbox check and uncheck
  availableCheckboxChange(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let allData =[];

    this.availableForCheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label != 'All'){
        allData.push(item);
      }
    });

    if (event.target.checked == true) {
      this.ischeckedJobClassification = true;
      if (lable == 'All') {
        for (let key of this.availableForCheckboxes) {
          if (key.label != 'All' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }

      }
      // this.filterWhenNoneCandidateSouce();

      if(allData.every(x=> x.selected == true)){
        this.availableForCheckboxes[0].selected = true;
      }
    }
    if (event.target.checked == false) {
      if (lable != 'All') {
        this.availableForCheckboxes[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.availableForCheckboxes) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      }
    }

    this.applyFilternew(param);
    this.updateFunction();
  }

  jobclassifiCheckAll(event) {
    const checked = event.target.checked;
    this.availableForCheckboxes.forEach(item => item.selected = checked);
  }

  //  client type check and uncheck
  workAuthcheckbox(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    this.WACheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
    });



    if (event.target.checked == true) {
      this.ischeckedClientType = true;

      if (lable == 'All') {
        for (let key of this.WACheckboxes) {
          if (key.label != 'All') {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      } else {
        this.candidateSource.push(lable);
        this.candidateSource = [...new Set(this.candidateSource)]
      }
      // this.filterWhenNoneCandidateSouce()
    }

    if (event.target.checked == false) {
      if (lable != 'All') {
        this.WACheckboxes[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }

      }

      if (lable == 'All') {
        for (let key of this.WACheckboxes) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      }

    }

    if (this.ischeckedClientType && this.ischeckedClientTypeAll) {
      event.target.checked = true
    }
    this.applyFilternew(param);
    this.updateFunction();
  }

  clientTypeCheckedAll(event) {
    const checked = event.target.checked;
    this.WACheckboxes.forEach(item => item.selected = checked);

  }

  // submit status filed code
  candidate_status_check(event, lable) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    this.selectedSubmission = [];


    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (lable == 'ALL') {
        for (let key of this.submissionFilter) {
          if (key.label != 'ALL' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.candidate_CheckAll(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }
      }

      this.resetFilterDefault();

      // clear source values and default check my canidate
      this.candidateSource = [];
      this.candidateSource.push("myCandidates");
      this.candidateSource = [...new Set(this.candidateSource)];
      this.jobsouceCheckedAll(false);
      this.jobSourcesFormarray.at(0).get('myCandidates').patchValue(true);


      // for (let key of this.keyarrayCandidatesouces) {

      //   if (key == 'myCandidates') {
      //     ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).setValue(true);
      //   } else {
      //     ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).setValue(false);
      //   }

      //   // Clear source values from seleted.
      //   if (this.candidateSource.includes(key)) {
      //     if (key != 'myCandidates') {
      //       this.candidateSource.splice(this.candidateSource.indexOf(key), 1);
      //       this.candidateSource = [...new Set(this.candidateSource)]
      //     }
      //   }

      // }




    }
    else if (event.target.checked == false) {
      if (lable != 'ALL') {
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }

      if (lable == 'ALL') {
        for (let key of this.submissionFilter) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.candidate_CheckAll(event);
      }
    }

    this.submissionFilter = this.submissionFilter.map((item , i) => {
      if (item.itemId === lable) {
         item.selected = event.target.checked;
      }

      if(item.selected){
        this.selectedSubmission.push(item.itemId);
      }

      return item;
    });


    // clear all the selected business , personal network and customer if one of the submission element  is checked
    this.selectedBusinessNetworks = [];
    this.selectedCustomers = [];
    this.selectedPublishedBy = [];
    this.customerPrevSelectedValue = [];
    this.businessNetworkPrevSelectedValue = [];
    this.publishedByPrevSelectedValue = [];
    this.setToDefaulFilter();
    this.setToDefaulFilter("CUSTOMER");

    this.updateFunction();
  }

  candidate_CheckAll(event) {
    const checked = event.target.checked;
    this.submissionFilter.forEach(item => item.selected = checked);

  }

  // status check and uncheck
  statuscheck(event, lable) {
    this.stopscrollFlag = false;
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = [];
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let allData =[];

    this.statusCheckboxes.forEach(item => {
      if (lable === 'Available') {
        this.activeStatus = true
      }
      else {
        this.activeStatus = false
      }
      if (item.label == lable) {
        item.selected = event.target.checked;
      }

      if(item.label != 'All'){
        allData.push(item);
      }
    });

    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (key.label != 'All' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.statusCheckAll(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }
      }

      if(allData.every(x=> x.selected == true)){
        this.statusCheckboxes[0].selected = true;
      }
    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.statusCheckboxes[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }


      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.statusCheckAll(event);
      }

    }

    // if (this.activeStatus) {
    //   if (!this.owner) {
    //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

    //       for (let key of this.keyarrayCandidatesouces) {
    //         if (key != "myCandidates") {
    //           ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
    //           if (key != 'all') {
    //             this.candidateSource.push(key);
    //             this.candidateSource = [...new Set(this.candidateSource)]
    //           }

    //         }
    //       }

    //     }
    //   }

    //   if (this.owner) {
    //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').patchValue(true);
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').patchValue(true);
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').patchValue(true);
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').patchValue(true);
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').patchValue(true);
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

    //       this.candidateSource.push("myCandidates");
    //       this.candidateSource.push("teamCandidates");
    //       this.candidateSource.push("benchNetworkCandidates");
    //       this.candidateSource.push("freeLancerNetworkCandidates");
    //       this.candidateSource.push("mtaNetworkCandidates");
    //       this.candidateSource.push("jobSeekerNetworkCandidates");
    //       if (!this.FeaSugg) {
    //         this.candidateSource.push("featured");
    //         this.candidateSource.push("suggestedCandidates");
    //       }

    //       this.candidateSource = [...new Set(this.candidateSource)]
    //     }
    //   }
    //   this.activeStatus = null;
    // }
    // else if (!this.activeStatus) {
    //   if (this.owner) {
    //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

    //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);

    //       this.candidateSource.push("myCandidates");

    //       this.candidateSource = [...new Set(this.candidateSource)]
    //     }
    //   }
    //   this.activeStatus = null;

    // }


    this.updateFunction();
  }
  workModeChange(checked, label) {
    if (label === 'All') {

      if (checked) {
        this.workModeCheckboxes.forEach(item => item.selected = true);
      }
      else if (!checked) {
        this.workModeCheckboxes.forEach(item => item.selected = false);
      }
    }
    else if (label != 'All') {

      this.workModeCheckboxes.forEach(item => {
        if (item.label === label) {
          item.selected = checked;
        }
      });

      const isAllchecked = this.workModeCheckboxes.filter(val => val.label != 'All').every(item => item.selected === true);
      this.workModeCheckboxes[0].selected = isAllchecked;

    }
    this.updateFunction();
  }

  statusCheckAll(event) {
    const checked = event.target.checked;
    this.statusCheckboxes.forEach(item => item.selected = checked);

  }


  // filterWhenNoneCandidateSouce() {
  //   if (!this.owner) {
  //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {


  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

  //       this.candidateSource.push("teamCandidates");
  //       this.candidateSource.push("benchNetworkCandidates");
  //       this.candidateSource.push("freeLancerNetworkCandidates");
  //       this.candidateSource.push("mtaNetworkCandidates");
  //       this.candidateSource.push("jobSeekerNetworkCandidates");
  //       if (!this.FeaSugg) {
  //         this.candidateSource.push("featured");
  //         this.candidateSource.push("suggestedCandidates");
  //       }

  //       this.candidateSource = [...new Set(this.candidateSource)]
  //     }
  //   }
  //   else if (this.owner) {
  //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

  //       // ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);

  //       // this.candidateSource.push("myCandidates");

  //       // this.candidateSource = [...new Set(this.candidateSource)]
  //     }
  //   }
  // }

  removeEntitynew(value, index) {

    if (this.jobfilter != true) {

      this.candidateFilterForm.value.searchAfterKey = null
      this.response = []
      this.obj.searchAfterKey = null;
      this.obj1.searchAfterKey = null;
      this.previousSearchAfterKey = null;
      this.previousSearchAfterKey1 = null;

      this.stopscrollFlag = false

      this.candidateSource.splice(index, 1);
      if (this.keyarrayCandidatesouces.includes(value)) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }
      if (this.keysarrWorks.includes(value)) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }

      this.WACheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.WACheckboxes[0].selected = false
        }
      });

      this.statusCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.statusCheckboxes[0].selected = false
        }
      });

      this.availableForCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.availableForCheckboxes[0].selected = false
        }
      });

      this.availablecheckbox.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.availablecheckbox[0].selected = false
        }
      });


      this.candidate_status.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.candidate_status[0].selected = false
        }
      });

      if (value == 'myCandidates') {
        this.response = []
        this.obj.searchAfterKey = null;
        this.obj1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      // this.applyFilternew();
    }
  }

  chatbottom() {
    let seletedItem: any = {};
    // this._socket.ngOnDestroy();
    // this._socket.connections();
    seletedItem.owner = true;
    this.messagemodelflag = true;
    seletedItem.userId = localStorage.getItem('userId');
    this.messageData = [];
    seletedItem.groupType = "CANDIDATE";
    seletedItem.messageType = "CANDIDATE";
    seletedItem.id = null;
    // Bottom chat: also load direct USER-to-USER contacts (message/new/contact/{userId})
    // and merge them into the list, same as the Home page bottom chat.
    seletedItem.bottomChat = true;
    this.messageData = seletedItem;
  }

  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();

  }

  onFilterToggle(value: any) {
    const receivedData = JSON.parse(value);
    // this.data1 = receivedData.jobForm;
    // this.jobSource = receivedData.jobSource;
    // this.filterapicall()
  }

  openFilterSlider() {
    if (!this.isFilterOpen) {
      this.isFilterOpen = true;
      this.jobService.setSliderToggle(true, 'candidate-listing', null,false);
    }
  }

  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'candidate-listing', null,false);
    }
  }
  @Output() panelValue = new EventEmitter<any>(null);

  onMenuItemClick(event, param?: any): void {
    event.stopPropagation();

    if (param != null) {
      // this.meunTrigger.closeMenu();
    }
  }

  onMemberNetworkSearch(e){

  }

  onMemberNetworkScroll(e){

  }

  onBusinessNetworkSearch(e){

  }

  onBusinessNetworkScroll(e){

  }


  onCustomerSearch(e){
    this.customerPayload.searchContent= e;
    this.setToDefaulFilter("CUSTOMER");
    this.getBusinessCustomers(this.memberAvailable ? "MEMBER_NETWORK" : "BUSINESS-NETWORK");
  }

  onCustomerScroll(e){
    if(!this.customersStopScroll && JSON.stringify(this.customerPayload.searchAfterKey) != JSON.stringify(this.customersPrevSearchAfterKey)){
      this.customerPayload = {
        ...this.customerPayload,
        searchAfterKey : this.customersPrevSearchAfterKey
      }
      this.getBusinessCustomers(this.memberAvailable ? "MEMBER_NETWORK" : "BUSINESS-NETWORK", 'scroll');
   }
  }

  onPublishSearch(e){
    this.publishedPayload.searchContent = e;
    this.setToDefaulFilter();
    this.getPublishedBy();
  }

  onPublishScroll(e){
    if(!this.publishedByStopScroll && JSON.stringify(this.publishedPayload.searchAfterKey) != JSON.stringify(this.publishedByPrevSearchAfterKey)){
      this.publishedPayload = {
        ...this.publishedPayload,
        searchAfterKey : this.publishedByPrevSearchAfterKey
      }
      this.getPublishedBy();
    }
  }

  onEmployeeSearch(term: string) {
    this.employeeSearch.emit(term || "");
  }

  onEmployeeScroll(_: any) {
    this.employeeScroll.emit();
  }


  getResult(data){
    return (data.memberNetworkChosen && (data.personalNetworks && data.personalNetworks.length > 0)) ? ['Personal Networks' , "Member Network"] :
    (data.memberNetworkChosen && (data.personalNetworks && data.personalNetworks.length === 0)) ? ['Member Network'] :
    (!data.memberNetworkChosen && (data.personalNetworks && data.personalNetworks.length > 0)) ? ['Personal Networks']  :
    ['Personal Networks' , 'Member Network'];
  }


  // Only the checkboxes the template actually renders — mirrors the *ngIf's in
  // the Source panel. Commented-out / hidden controls (benchNetworkCandidates,
  // featured, myEmployees, …) can never be ticked one by one, so they mustn't
  // block the auto-"All".
  private visibleSourceKeys(): string[] {
    const keys = ['marketPlaceCandidates', 'memberNetworksCandidates'];
    if (this.owner) keys.push('myCandidates');
    if (!this.filterApplied) {
      keys.push(...(this.personalNetworks || []).map(x => x.key));
      if (this.userType != GigsumoConstants.JOB_SEEKER) keys.push('teamCandidates');
    }
    if (this.userType != GigsumoConstants.JOB_SEEKER && this.businessNetworkData?.length > 0) keys.push('businessNetwork');
    return keys;
  }

  checkIfAllSourceIsSelected() {
    // SuperAdmin org view hides the "All" checkbox — never auto-tick it there.
    if (this.orgCandidatesMode) return false;
    const group = this.jobSourcesFormarray.at(0) as UntypedFormGroup;
    if (!group) return false;
    return this.visibleSourceKeys().every(key => group.get(key)?.value === true);
  }

  // Filter count methods for each section
  getBadgeClass(count: number): string {
    return count >= 10 ? 'filter-count-badge double-digit' : 'filter-count-badge';
  }

  // Candidate Source badge = ticked checkboxes only, same rules as the horizontal
  // row (candidate-filter-template.computeSourceCount): skip the "all" toggle,
  // skip "myEmployees" unless the SuperAdmin org view renders it, and skip the
  // two role/plan keys that are never a real user pick. Picker selections
  // (Published By / Business Networks / Customer) are NOT added here — each
  // picker shows its own sub-badge, and summing them inflated this number.
  getCandidateSourceCount(): number {
    const group = this.jobSourcesFormarray && this.jobSourcesFormarray.at(0) as FormGroup;
    if (!group) { return 0; }
    const userType = localStorage.getItem('userType');
    return Object.keys(group.controls).reduce((count, key) => {
      if (key === 'all') { return count; }
      if (key === 'myEmployees' && !this.orgCandidatesMode) { return count; }
      if (key === 'myCandidates' && userType === GigsumoConstants.RECRUITER) { return count; }
      if (key === 'businessNetwork' && (this.membershipType === 'Free' || this.membershipType === 'Pro')) { return count; }
      return count + (group.get(key)?.value === true ? 1 : 0);
    }, 0);
  }

  getAvailabilityCount(): number {
    if (this.availablecheckbox && Array.isArray(this.availablecheckbox)) {
      return this.availablecheckbox.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getEngagementTypeCount(): number {
    if (this.availableForCheckboxes && Array.isArray(this.availableForCheckboxes)) {
      return this.availableForCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getStatusCount(): number {
    if (this.statusCheckboxes && Array.isArray(this.statusCheckboxes)) {
      return this.statusCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getSubmissionStatusCount(): number {
    if (this.submissionFilter && Array.isArray(this.submissionFilter)) {
      return this.submissionFilter.filter(item => item.selected && item.label !== 'ALL').length;
    }
    return 0;
  }

  getLocationCount(): number {
    let count = 0;
    if (this.candidateFilterForm) {
      const formValues = this.candidateFilterForm.getRawValue();
      if (formValues.country && formValues.country !== 'null') count++;
      if (formValues.state && formValues.state !== 'null') count++;
      if (formValues.city && formValues.city !== 'null') count++;
      if (formValues.zipCode && formValues.zipCode !== 'null') count++;
    }
    return count;
  }

  getWorkAuthorizationCount(): number {
    if (this.WACheckboxes && Array.isArray(this.WACheckboxes)) {
      return this.WACheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getWorkModeCount(): number {
    if (this.workModeCheckboxes && Array.isArray(this.workModeCheckboxes)) {
      return this.workModeCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getTotalExperienceCount(): number {
    if (this.candidateFilterForm) {
      const experienceType = this.candidateFilterForm.get('experienceType')?.value;
      return (experienceType && experienceType !== 'Any (Years)') ? 1 : 0;
    }
    return 0;
  }

  getPostedDaysCount(): number {
    if (this.candidateFilterForm) {
      const postedDayRange = this.candidateFilterForm.get('postedDayRange')?.value;
      return (postedDayRange && postedDayRange !== 'Any (Days)') ? 1 : 0;
    }
    return 0;
  }

  // Methods for sub-section counts
  getPublishedByCount(): number {
    if (this.selectedPublishedBy && Array.isArray(this.selectedPublishedBy)) {
      return this.selectedPublishedBy.length;
    }
    return 0;
  }

  getEmployeeCount(): number {
    if (this.selectedEmployees && Array.isArray(this.selectedEmployees)) {
      return this.selectedEmployees.length;
    }
    return 0;
  }

  getCustomerCount(): number {
    if (this.selectedCustomers && Array.isArray(this.selectedCustomers)) {
      return this.selectedCustomers.length;
    }
    return 0;
  }

  // Count the checked Business Networks. Reads businessNetworkData (the same
  // [filterData] source the checkboxes bind to) rather than
  // selectedBusinessNetworks, because onSelectChange overwrites the latter with
  // allBusinessNetwork when the user's picks reduce to empty (select-all
  // fallback) — counting `enabled` items always matches the visible checkboxes.
  getBusinessNetworkCount(): number {
    if (this.businessNetworkData && Array.isArray(this.businessNetworkData)) {
      return this.businessNetworkData.filter(x => x.enabled === true).length;
    }
    return 0;
  }




}

